import { BoardingCertificateCommon } from '@common/interfaces/boarding-certificate';

/**
 * BoardingCertificateCommon model details
 */
export interface BoardingCertificateCommonStateDetails {}

/**
 * BoardingCertificateCommon store state
 */
export interface BoardingCertificateCommonState extends BoardingCertificateCommonStateDetails {
  model: BoardingCertificateCommon | null;
}

/**
 * Name of the BoardingCertificateCommon Store
 */
export const BOARDING_CERTIFICATE_COMMON_STORE_NAME = 'boardingCertificateCommon';

/**
 * BoardingCertificateCommon Store Interface
 */
export interface BoardingCertificateCommonStore {
  /** BoardingCertificateCommon state */
  [BOARDING_CERTIFICATE_COMMON_STORE_NAME]: BoardingCertificateCommonState;
}
